var map = {
	"./audio-muted.svg": 5764,
	"./audio.svg": 9601,
	"./copy.svg": 2226,
	"./github.svg": 2084,
	"./language.svg": 6643,
	"./video-muted.svg": 2272,
	"./video.svg": 8150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;